import axios from '@/http/index';

const base = '';

// (4.7)修改顾客信息
export const saveOrUpdate = (param) => axios.post(`${base}/erp/customer/saveOrUpdate`, param).then((res) => res.data);

// 获得一个顾客信息详情
export const getOneCustomerMsg = (params) => axios.get(`${base}/erp/customer/getOneCustomerMsg`, params).then((res) => res.data);

// (4.7.0)获得顾客信息列表
export const getCustomerMsgListPage = (params) => axios.post(`${base}/erp/customer/getCustomerMsgListPage`, params).then((res) => res.data);

// (4.7.0)获得会员等级列表
export const getGradeList = (params) => axios.get(`${base}/erp/customer/getGradeList`, params).then((res) => res.data);
// (4.7.0)导出顾客信息
export const exportCustomerList = (params) => axios.get(`${base}/erp/customer/export/exportCustomerList`, params).then((res) => res.data);
// (4.7.0)导出顾客套餐信息
export const exportCustomerPackageList = (params) => axios.get(`${base}/erp/customer/export/exportCustomerPackageList`, params).then((res) => res.data);
// 获得新增会员跳转链接
export const getMemberUrl = (params) => axios.get(`${base}/erp/member/getMemberUrl`, params).then((res) => res.data);

// （6.4）查询顾客是否已经存在(有数据则存在，没有数据则不存在)
export const saveMsg = (param) => axios.post(`${base}/erp/customer/saveMsg`, param).then((res) => res.data);

// （6.4）查询顾客是否已经存在(有数据则存在，没有数据则不存在)
export const fetchPolice = (param) => axios.get(`${base}/erp/customer/upload/fetch-police`, param).then((res) => res.data);

// （6.7）查询全部套餐列表
export const getVipCardNameAndIdDTOList = (param) => axios.get(`${base}/erp/customer/getVipCardNameAndIdDTOList`, param).then((res) => res.data);

// （6.8.1）查询顾客是否能删除（ 1：是 ,-1:非创建顾客的门店不可删除,-2:该顾客已有使用记录，不可删除!，-3：会员顾客不可删除）
export const getDeleteCustomerInfoStatus = (param) => axios.get(`${base}/erp/customer/getDeleteCustomerInfoStatus`, param).then((res) => res.data);

// (6.8.2)获得无手机号顾客套餐记录
export const getNoPhoneCustomerPackageList = (param) => axios.get(`${base}/erp/customer/getNoPhoneCustomerPackageList`, param).then((res) => res.data);

// (6.8.2)获得导入历史记录
export const getImportRecordList = (param) => axios.get(`${base}/erp/customer/getImportRecordList`, param).then((res) => res.data);

// (6.8.2)激活或者合并无手机号的顾客套餐
export const bindingCustomerPackage = (param) => axios.get(`${base}/erp/customer/bindingCustomerPackage`, param).then((res) => res.data);

// (6.8.2)删除未激活或者未合并无手机号的顾客套餐
export const deleteCustomerPackage = (param) => axios.get(`${base}/erp/customer/deleteCustomerPackage`, param).then((res) => res.data);
